import PropTypes from 'prop-types'
import React, { useState } from 'react'
import classNames from 'classnames'
import { Button, Stack, styled } from '@mui/material'
import '../../assets/css/components/shared/location-fields.sass'
import { addToDataLayer_nextgen } from '@helpers/google-tag-manager'

const propOptions = { shouldForwardProp: prop => prop !== 'isMobile' }

const StyledSearchButton = styled(
  Button,
  propOptions,
)(({ isMobile }) => ({
  marginTop: '0!important',
  padding: '0.5rem 2rem',
  fontSize: '15px',
  fontWeight: 600,
  maxWidth: '100px',
  maxHeight: '40px',
  ...(isMobile && {
    fontSize: '0.8rem',
  }),
}))

const StyledInput = styled('input')({
  fontSize: '16px',
  borderRadius: '4px !important',
  margin: '0 !important',
})

const LocationFields = ({ inputRef, error, addressInput, onChange, noAutoComplete, id, isLoading }) => {
  const [isEmpty, setIsEmpty] = useState(true)
  const stopTabPropagation = event => {
    if (event.key === 'Tab') {
      event.stopPropagation()
    }
  }

  const handleChange = e => {
    const currIsEmpty = typeof inputRef?.current?.value !== 'string' || inputRef?.current?.value.trim() === ''
    setIsEmpty(currIsEmpty)
    onChange(e)
  }

  return (
    <div className="location-fields">
      <label className="label-header" htmlFor={`location${id}`}>
        {error && (
          <div className="error">
            <span className="hide508">(Error - Invalid location input)</span>
            <p>*Please enter a valid USA city and state, or zip code.</p>
          </div>
        )}
      </label>
      <Stack direction="row" spacing={1}>
        <StyledInput
          ref={inputRef}
          type="text"
          className={classNames(
            'input-field',
            {
              error,
            },
            'shipping',
          )}
          name="location"
          id={`location${id}`}
          aria-required="true"
          aria-invalid={!!error}
          placeholder="City & State or Zip Code"
          value={addressInput}
          onChange={handleChange}
          autoComplete={noAutoComplete ? 'off' : ''}
          onKeyDown={stopTabPropagation}
        />
        <StyledSearchButton
          className="shipping"
          variant="contained"
          color="primary"
          fullWidth
          type="submit"
          onKeyDown={stopTabPropagation}
          onClick={() => {
            addToDataLayer_nextgen('change_delivery_location')
          }}
          disabled={isEmpty || isLoading}
        >
          UPDATE
          <span className="hide508">(refreshes the page with new delivery location)</span>
        </StyledSearchButton>
      </Stack>
    </div>
  )
}

LocationFields.propTypes = {
  addressInput: PropTypes.any,
  error: PropTypes.any,
  id: PropTypes.any,
  inputRef: PropTypes.any,
  noAutoComplete: PropTypes.any,
  onChange: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default LocationFields
